import { render, staticRenderFns } from "./family.vue?vue&type=template&id=6ede83e0&scoped=true&"
import script from "./family.vue?vue&type=script&lang=ts&"
export * from "./family.vue?vue&type=script&lang=ts&"
import style0 from "./family.vue?vue&type=style&index=0&id=6ede83e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ede83e0",
  null
  
)

export default component.exports